import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AccessRole, ButtonColumnType, CustomTableComponent, DataColumnType, DATE_WITH_HOUR_FORMAT, ICustomTable, LoadingPanelService, LocalService, Page } from 'lib-base';
import { TableLazyLoadEvent } from 'primeng/table';
import { firstValueFrom, forkJoin } from 'rxjs';
import { SolicitudRevocacionService } from '../../../services/database/solicitud-revocacion.service';
import { ISolicitudRevocacion } from '../../../shared/interfaces/database/firma_electronica';
import { Router } from '@angular/router';

@Component({
  selector: 'app-revocaciones-pendientes',
  standalone: true,
  imports: [CustomTableComponent],
  template: `
  <custom-table [config]="customTable" (emitterLazyLoad)="lazyloadRecords($event)">
  </custom-table>
  `
})
export class RevocacionesPendientesComponent implements OnInit {

  trans: any = {};
  customTable !: ICustomTable;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;
  role = AccessRole;

  constructor(private readonly _t: TranslateService, private readonly _sr: SolicitudRevocacionService, private readonly _lps: LoadingPanelService,
    public ls: LocalService, private readonly _router: Router
  ) { }

  ngOnInit(): void {
    this.translate().then(() => this.configurarTabla());
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      fechaActualización: this._t.get('common.fechaActualización'),
      fechaSolicitud: this._t.get('common.fechaSolicitud'),
      noSolicitud: this._t.get('common.noSolicitud'),
      abrir: this._t.get('common.abrir'),
      motivoRevocacion: this._t.get('common.motivoRevocacion')
    }));
  }

  configurarTabla(): void {
    this.customTable = {
      header: {},
      columns: [
        {
          field: 'id',
          header: this.trans.noSolicitud,
          class: 'font-13',
          width: '2rem',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
          },
          dataType: DataColumnType.TEXT
        },
        {
          field: 'motivoRevocacion',
          header: this.trans.motivoRevocacion,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold'
          },
          dataType: DataColumnType.TEXT
        },
        {
          field: 'fechaSolicitud',
          header: this.trans.fechaSolicitud,
          sort: true,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold'
          },
          format: DATE_WITH_HOUR_FORMAT,
          dataType: DataColumnType.DATE,
        },
        {
          field: 'abrir',
          header: '',
          label: this.trans.abrir,
          icon: 'pi pi-folder-open',
          class: 'button-edit p-button-outlined pt-2 pb-2',
          width: '0rem',
          buttonType: ButtonColumnType.CUSTOM,
          onClick: (event: Event, data: ISolicitudRevocacion) => this.onClick(data),
          disabled: !this.ls.hasRole(this.role.GESTION_FIRMA_ELECTRONICA)
        }
      ],
      settings: {
        table: {
          rows: 8,
          lazy: true
        }
      }
    } as ICustomTable;
  }

  getRevocacionesPendientes(event?: TableLazyLoadEvent) {
    this._sr.getSolicitudesPendientes(event).subscribe({
      next: (data: Page<ISolicitudRevocacion>) => {
        this._lps.hide();
        this.customTableComponent.data = data.content;
        this.customTableComponent.totalRecords = data.totalElements;
      }
    });
  }

  lazyloadRecords(event: TableLazyLoadEvent) {
    this.getRevocacionesPendientes(event);
  }

  onClick(data: ISolicitudRevocacion) {
    this._router.navigate(['/configuracion/firma-electronica/revocaciones/seguimiento/', data.id]);
  }
}
